import '../util/aria.js';
import { LitElement, html, property, customElement } from 'lit-element';
import { cssResult } from '../util/css.js';
import { __decorate, __metadata } from 'tslib';
import { sharedStyles } from '../style/shared.js';
import styles from './divider.scss.js';

let Divider = class Divider extends LitElement {
    constructor() {
        super(...arguments);
        this.role = 'separator';
        this.vertical = false;
    }
    render() {
        return html` <slot></slot> `;
    }
};
Divider.styles = [
    cssResult(styles),
    sharedStyles
];
__decorate([
    property({
        type: String,
        reflect: true
    }),
    __metadata('design:type', String)
], Divider.prototype, 'role', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], Divider.prototype, 'vertical', void 0);
Divider = __decorate([customElement('wl-divider')], Divider);

export { Divider };
